"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _Menu = require("./Menu.styles");

var _MenuItem = _interopRequireDefault(require("./MenuItem/MenuItem"));

var _UnmanagedMenuItem = _interopRequireDefault(require("./MenuItem/UnmanagedMenuItem"));

var _SubMenu = _interopRequireDefault(require("./SubMenu/SubMenu"));

var _Menu2 = _interopRequireDefault(require("./Menu.provider"));

var Menu = function Menu(_ref) {
  var className = _ref.className,
      controls = _ref.controls,
      children = _ref.children,
      title = _ref.title,
      footer = _ref.footer,
      header = _ref.header,
      headingCls = _ref.headingCls,
      tight = _ref.tight,
      animate = _ref.animate,
      dataTestId = _ref.dataTestId;
  return (0, _jsxRuntime.jsx)(_Menu2["default"], {
    tight: tight,
    animate: animate,
    children: (0, _jsxRuntime.jsxs)("div", {
      css: _Menu.styles.base,
      className: className,
      "data-test-id": dataTestId,
      children: [header || (0, _jsxRuntime.jsxs)("div", {
        css: _Menu.styles.heading,
        className: (0, _clsx["default"])('grui pl-12 pr-10 pb-5 pt-10', headingCls),
        children: [(0, _jsxRuntime.jsx)("h4", {
          css: _elements.heading.styles.h5,
          children: title
        }), (0, _jsxRuntime.jsx)("div", {
          css: _Menu.styles.controls,
          className: "menu-controls",
          children: controls
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        css: _Menu.styles.scrollingContainer,
        children: (0, _jsxRuntime.jsx)("div", {
          css: [_elements.text.styles.textXs, _Menu.styles.list, process.env.NODE_ENV === "production" ? "" : ";label:Menu;"],
          className: (0, _clsx["default"])('grui pb-10', 'menu-list'),
          "data-test-id": "menu-list",
          children: children
        })
      }), footer]
    })
  });
};

Menu.propTypes = {
  className: _propTypes.string,
  controls: _propTypes.node,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  footer: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * Customizing header instead of passing title
   */
  header: _propTypes.node,

  /**
   * Class for heading
   */
  headingCls: _propTypes.string,
  tight: _propTypes.bool,
  animate: _propTypes.bool,
  dataTestId: _propTypes.string
};
Menu.defaultProps = {
  className: undefined,
  controls: undefined,
  children: undefined,
  title: undefined,
  footer: undefined,
  header: undefined,
  headingCls: undefined,
  tight: false,
  animate: true,
  dataTestId: undefined
};
Menu.Item = _MenuItem["default"];
Menu.UnmanagedItem = _UnmanagedMenuItem["default"];
Menu.SubMenu = _SubMenu["default"];
var _default = Menu;
exports["default"] = _default;
//# sourceMappingURL=Menu.js.map